<div class="not-found">
  <h1>A dokumentum aláírása sikeres!</h1>
  <h2>Az oldal be fog záródni:</h2>
  <h1>{{countdown}}</h1>
</div>
